<template>
  <div>
    <div v-if="!pageLoading && !isPageError">
      <v-row>
        <v-col>
          <div class="d-flex align-center">
            <v-text-field
              v-model="searchOrder"
              solo
              background-color="chip"
              rounded
              height="56px"
              persistent-placeholder
              hide-details
              class="mr-3"
              @input="searchOrderChange()"
              :prepend-inner-icon="icons.mdiMagnify"
              placeholder="Ürünler içerisinde adına, kategorisine veya koduna göre arama"
              clearable
            />

            <!-- TODO  -->

            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  fab
                  :color="searchOrderCategory ? 'error' : 'chip'"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-tooltip
                    top
                    nudge-top="15"
                    :color="searchOrderCategory ? 'error' : 'secondary'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        {{
                          searchOrderCategory
                            ? icons.mdiFilterOff
                            : icons.mdiFilterVariant
                        }}
                      </v-icon>
                    </template>
                    <span v-if="searchOrderCategory"
                      >{{ searchOrderCategory }} Kategorisindesiniz</span
                    >
                    <span v-else>Kategoriye göre filitreleme</span>
                  </v-tooltip>
                </v-btn>
              </template>

              <v-list nav color="chip">
                <v-list-item-group v-model="selectedCategory" color="primary">
                  <v-list-item
                    v-if="searchOrderCategory"
                    @click="filterCategorys('')"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2"
                        >Tümü</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-for="(item, i) in orderCategorys"
                    :key="i"
                    @click="filterCategorys(item.kategori)"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2">{{
                        item.kategori
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item></v-list-item-group
                >
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="filterOrderItems.length > 0" class="mt-3">
        <v-col
          v-for="orderItem in filterOrderItems"
          :key="`${orderItem.id}-order-id`"
          cols="12"
          md="4"
          sm="6"
        >
          <OrderCard
            @countEvent="countEvent"
            :orderItem="orderItem"
          ></OrderCard>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <v-alert text rounded="pill" type="warning" prominent dense
            >Aramanız için bir sonuç bulunamadı</v-alert
          >
        </v-col>
      </v-row>

      <v-row v-if="isBasket" class="mb-n12">
        <v-col>
          <v-alert text rounded="pill" type="error" prominent dense
            >Her hangi bir ürün sepetinizde yok</v-alert
          >
        </v-col>
      </v-row>

      <v-row align="center" class="my-md-9 mb-9">
        <v-col cols="12" v-if="!minOrderPrice">
          <v-alert text type="warning">
            En az {{ callCenterStore.minOrderPrice | currency }} sipariş
            girilmesi gerekiyor ondan sonra devam edebilirsiniz
          </v-alert>
        </v-col>
        <v-col cols="12" sm="6">
          <v-btn
            class="text-capitalize"
            plain
            x-large
            block
            rounded
            @click="callCenterStore.decrease()"
            >Geri Git
          </v-btn>
        </v-col>
        <!-- <v-col cols="12" sm="3">
          <v-btn
            class="text-capitalize"
            color="warning"
            x-large
            outlined
            block
            depressed
            rounded
            @click="basketTrash()"
            >Temizle
          </v-btn>
        </v-col> -->
        <v-col cols="12" sm="6">
          <v-btn
            color="secondary"
            class="text-capitalize"
            depressed
            rounded
            x-large
            block
            :disabled="!minOrderPrice"
            @click="continueStep()"
          >
            Devam Et
          </v-btn>
        </v-col>
      </v-row>

      <!-- <OrderBasket /> -->
    </div>
    <v-card
      v-if="pageLoading"
      rounded="pill"
      color="primary"
      outlined
      :loading="true"
    >
      <v-card-title class="text-center white--text">
        <v-progress-circular indeterminate color="white" />
        <div class="white--text text-body-2 pl-4">
          {{ pageLoadingMessage }}
        </div>
      </v-card-title>
    </v-card>
    <v-card
      v-if="isPageError"
      rounded="pill"
      color="error"
      outlined
      :loading="true"
    >
      <v-card-title class="text-center white--text">
        <v-icon color="white" size="32">
          {{ icons.mdiAlertCircle }}
        </v-icon>

        <div class="white--text text-body-2 pl-4">{{ pageErrorMessage }}</div>
        <v-spacer />
        <v-btn
          color="tertiary"
          small
          depressed
          rounded
          class="text-caption text-capitalize white--text"
          @click="reOrderFetch()"
        >
          <v-icon left>{{ icons.mdiRefresh }}</v-icon>
          Tekrar Dene</v-btn
        >
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";

import { postData } from "@utils";
import { useRouter } from "@core/utils";

// Store
import { useCallCenterStore } from "@/stores/callCenter";

// Components
import OrderCard from "./Card.vue";
import OrderBasket from "./Basket.vue";

// Icons
import {
  mdiMagnify,
  mdiAlertCircle,
  mdiMinusThick,
  mdiPlusThick,
  mdiRefresh,
  mdiFilterVariant,
  mdiFilterOff,
} from "@mdi/js";

export default {
  components: {
    OrderCard,
    OrderBasket,
  },
  setup() {
    // Store bağlantı
    const callCenterStore = useCallCenterStore();

    // Utils
    const { route } = useRouter();

    // API istek
    const orderItems = ref([]);
    const pageLoading = ref(true);
    const isPageError = ref(false);
    const pageErrorMessage = ref("");
    const pageLoadingMessage = ref("Yükleniyor lütfen bekleyin...");

    // Düzenleme yapılıyorsa siparişteki ürünleri içeri çek
    const productQuantity = (id) => {
      if (route.value.params.item) {
        let result = 0;
        callCenterStore.data.baskets.forEach((item) => {
          if (item.uid == id) {
            result = item.qty * 1;
          }
        });
        return result;
      } else {
        return 0;
      }
    };

    const orderFetch = async () => {
      isPageError.value = false;
      pageLoading.value = true;
      postData({
        method: "callCenterProductList",
      })
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error === 1) {
            throw new Error(response.msg);
          }

          orderItems.value = response.response.result.map((item) => {
            return {
              id: item.id,
              kid: item.mainCategoryName,
              urun_kodu: item.refno,
              kategori: item.mainCategoryName,
              baslik: item.productName,
              altBaslik: item.subtitle,
              quantity: productQuantity(item.id),
              birim: item.currency,
              resim: item.thumbnailUrl,
              satis_fiyati: item.totalPrice,
              filterText: item.productName + item.mainCategoryName,
            };
          });
        })
        .catch((e) => {
          // API hataya girdi
          isPageError.value = true;
          pageErrorMessage.value = e.message;
        })
        .finally(() => {
          // API işlemi bittikten sonra
          pageLoading.value = false;

          // Düzenleme yaptıktan sonra listeyi boşaltma
          callCenterStore.data.baskets = [];
        });
    };

    const reOrderFetch = async () => {
      pageLoadingMessage.value = "Tekrar deneniyor lütfen bekleyin";
      await orderFetch();
    };

    const isBasket = ref(false);

    // Miktar değişim olayları
    const countEvent = (val) => {
      isBasket.value = false;
      if (orderItems.value.find((item) => item.id === val[1])) {
        orderItems.value.find((item) => item.id === val[1]).quantity = val[0];
      }
    };

    // Kategorileri getir
    const orderCategorys = computed(() => {
      const result = [];

      const orderCategorysGroup = _.groupBy(orderItems.value, "kid");

      for (const [key, value] of Object.entries(orderCategorysGroup)) {
        result.push({
          id: value[0].kid,
          kategori: value[0].kategori,
        });
      }

      return result;
    });

    // Arama ve Filitreleme
    const searchOrder = ref("");
    const searchOrderChange = () => {
      searchOrderCategory.value = "";
      selectedCategory.value = null;
    };

    const selectedCategory = ref(null);
    const searchOrderCategory = ref("");

    const filterCategorys = (value) => {
      searchOrder.value = "";
      searchOrderCategory.value = value;
    };

    // Ürünler
    const filterOrderItems = computed(() => {
      return orderItems.value.filter((order) => {
        if (searchOrder.value === null) {
          return order;
        }

        const searchText = searchOrder.value || searchOrderCategory.value;
        return order.filterText
          .toLowerCase()
          .includes(searchText.toLowerCase());
      });
    });

    const minOrderPrice = computed(() => {
      const order = orderItems.value.filter((item) => item.quantity > 0);
      const total = order.reduce(
        (total, item) => total + item.quantity * item.satis_fiyati,
        0
      );
      return total > callCenterStore.minOrderPrice;
    });

    // Sayfa açılış
    onMounted(() => {
      orderFetch();
    });

    const continueStep = async () => {
      const basketTotal = orderItems.value.reduce(
        (total, item) => total + item.quantity,
        0
      );

      if (basketTotal > 0) {
        const data = orderItems.value.filter((item) => {
          if (item.quantity > 0) {
            return item;
          }
        });

        callCenterStore.data.products = data;

        if (callCenterStore.isInvoiceShow) {
          callCenterStore.increment();
        } else {
          callCenterStore.callCenterStep = 5;
        }
      } else {
        isBasket.value = true;
      }
    };

    return {
      isBasket,
      selectedCategory,
      countEvent,
      filterCategorys,
      searchOrder,
      searchOrderChange,
      filterOrderItems,
      callCenterStore,
      continueStep,
      pageLoading,
      pageErrorMessage,
      pageLoadingMessage,
      searchOrderCategory,
      isPageError,
      orderItems,
      minOrderPrice,
      reOrderFetch,
      orderCategorys,
      icons: {
        mdiMagnify,
        mdiPlusThick,
        mdiMinusThick,
        mdiAlertCircle,
        mdiRefresh,
        mdiFilterVariant,
        mdiFilterOff,
      },
    };
  },
};
</script>

<style></style>
